// MetaPixel.jsx
import { useEffect } from "react";

const MetaPixel = ({ pixelId = "899779694725440", trackPageView = true }) => {
    useEffect(() => {
        if (!window.fbq) {
            const script = document.createElement("script");
            script.async = true;
            script.src = "https://connect.facebook.net/en_US/fbevents.js";
            document.head.appendChild(script);

            window.fbq = function () {
                window.fbq.callMethod
                    ? window.fbq.callMethod.apply(window.fbq, arguments)
                    : window.fbq.queue.push(arguments);
            };
            if (!window._fbq) window._fbq = window.fbq;
            window.fbq.push = window.fbq;
            window.fbq.loaded = true;
            window.fbq.version = "2.0";
            window.fbq.queue = [];
        }

        if (!window.fbq._initializedIds) window.fbq._initializedIds = new Set();
        if (!window.fbq._initializedIds.has(pixelId)) {
            window.fbq("init", pixelId);
            window.fbq._initializedIds.add(pixelId);
        }

        if (trackPageView) {
            window.fbq("track", "PageView");
        }
    }, [pixelId, trackPageView]);


    // Note: <noscript> only helps if your app is server-rendered.
    return (
        <noscript>
            <img
                height="1"
                width="1"
                style={{ display: "none" }}
                src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
                alt=""
            />
        </noscript>
    );
};

export default MetaPixel;

// Optional helper you can import to fire events anywhere:
// export const fbqTrack = (...args) => window.fbq && window.fbq(...args);
